import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomTabComponent from 'components/CustomTab';
import { EnrollmentSolicitationList, UserSolicitationList } from 'views/UserSolicitation/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['button', 'label']);

  const tabComponents = [
    {
      label: t('title:User_solicitation.title_index_users'),
      component: <UserSolicitationList />,
    },
    {
      label: t('title:User_solicitation.title_index_enrollments'),
      component: <EnrollmentSolicitationList />,
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Typography variant="h4" style={{ marginBottom: 16 }}>
          {t('title:User_solicitation.title_index')}
        </Typography>
        <CustomTabComponent
          components={tabComponents}
          className={classes.tabs}
        />
      </div>
    </div>
  );
};
